//LOGIC:
//- change_request_setting = SettingService::ProviderSettings.get_setting(:change_requests)
//- if change_request_setting.enabled? && (change_request_setting.configurations.select{ |key, value| value == true }.keys & ["address_change", "insurance_change"]).any?

import React, { useContext } from 'react';
import { Typography, Link } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';

import styled from 'styled-components';
import { t } from '../../../../../../utils/i18next';
import { storeContext } from '../../../../../context';

const StyledContainer = styled.div`
  .link {
    vertical-align: baseline;
  }
`;

const BillingQuestions = observer(({ hideProviderName }) => {
  const {
    translations: { currentLanguage },
    payable: {
      payee: { provider }
    }
  } = useContext(storeContext);

  return (
    <>
      {provider && provider.name ? (
        <StyledContainer>
          <Typography gutterBottom variant={'h6'}>
            {t('payables.billing_questions.headline')}
          </Typography>
          {!hideProviderName && (
            <Typography>
              {provider.facilityName ? provider.facilityName : provider.name}
            </Typography>
          )}
          <Typography>
            {provider.tollFreePhone ? (
              <>
                {`${t('payables.billing_questions.local')} ${provider.phone}`}
                <br />
                {`${t('payables.billing_questions.toll_free')} ${
                  provider.tollFreePhone
                }`}
              </>
            ) : (
              <>{provider.phone}</>
            )}
          </Typography>
          <Typography>{provider.hoursOfOperation}</Typography>
          {provider.contactLink && (
            <Typography>
              <Trans
                i18nKey={'payables.billing_questions.contact_us'}
                components={[
                  <Link
                    key={0}
                    href={provider.contactLink}
                    rel="noopener noreferrer"
                    target="_blank"
                    color={'secondary'}
                    component="a"
                    variant={'body2'}
                    className={'link'}
                  >
                    placeholder
                  </Link>
                ]}
              />
            </Typography>
          )}
        </StyledContainer>
      ) : null}
    </>
  );
});

export default BillingQuestions;
